module.exports = __webpack_public_path__ + "img/solartooldatabase.53e1ed97.png";